import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Button,
  TextField,
  Box,
  Typography,
  FormControl,
  CircularProgress,
} from '@mui/material';
import { Link } from 'react-router-dom';
import logoIcon from '../../../../assets/common-assets/docu-transcribe-logo(1).png';
import {
  INVALID_INPUT_REGEX,
  RESET_PASSWORD,
  getHelperText,
} from '../../../../constants/staticContent';
import { classes } from './utils';
import { lightPalette } from '../../../../theme';
import { generateOTP } from '../../../../services/passwordApi';

const CodeSendThroughEmail = ({
  formData,
  setFormData,
  errors,
  setErrors,
  nextStep,
}) => {
  const [isLoader, setIsLoader] = useState(false);

  const validateEmptyField = (email) => email !== '';

  const emailRegex = INVALID_INPUT_REGEX.EMAIL;
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const isFirstLatterCapital = INVALID_INPUT_REGEX.EMAIL_CAPITAL.test(value);
    const isValidEmail = emailRegex.test(value);
    const emailValid = isValidEmail && isFirstLatterCapital;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));

    if (name === 'email') {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: value.trim() === '' || !emailValid,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isFirstLatterCapital = INVALID_INPUT_REGEX.EMAIL_CAPITAL.test(
      formData.email,
    );
    const isValidEmail = emailRegex.test(formData.email);
    const emailValid = isValidEmail && isFirstLatterCapital;
    const emailValid1 = validateEmptyField(formData.email);

    setErrors({
      email: !emailValid1 || !emailValid,
    });
    if (emailValid1 && emailValid) {
      const { email } = formData;
      setIsLoader(true);
      const response = await generateOTP(email);
      if (response) {
        setIsLoader(false);
        nextStep();
      } else {
        setIsLoader(false);
      }
    }
  };

  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={6.5}
      lg={7.5}
      className={classes.rightGridForAllStep}
    >
      <Box className={classes.rightGridMainBoxForAllStep}>
        <Box
          className={classes.logoBox}
          component="img"
          src={logoIcon}
          alt="logoIcon"
        />
        <Typography className={classes.resetPasswordHeader} variant="h4">
          {RESET_PASSWORD.HEADER}
        </Typography>
        <Typography
          variant="subtitle1"
          className={classes.rightBoxInfoSubtitleForAllStep}
          color={lightPalette.carbonFiber.semiDark}
        >
          {RESET_PASSWORD.INFO.STEP1}
        </Typography>
        <Box
          component="form"
          noValidate
          onSubmit={handleSubmit}
          className={classes.submitButton}
        >
          <FormControl className={classes.formControl}>
            <TextField
              className={classes.textFieldStepOne}
              required
              label={RESET_PASSWORD.TEXTFIELD_STEP_ONE.EMAIL}
              autoFocus
              id="email"
              name="email"
              autoComplete="email"
              onChange={handleInputChange}
              value={formData.email}
              error={errors.email}
              helperText={getHelperText('email', 'email', errors, formData)}
            />
            <Button
              type="submit"
              variant="contained"
              className={classes.formButtons}
            >
              {isLoader ? (
                <CircularProgress size="1.5rem" color="inherit" />
              ) : (
                <Typography variant="h5">
                  {RESET_PASSWORD.SEND_CODE_BUTTON}
                </Typography>
              )}
            </Button>
            <Typography variant="body1" className={classes.registerTypo}>
              {RESET_PASSWORD.RESET_PASS_LINK.TEXT}
              <Link to="/login" className={classes.loginLink}>
                {RESET_PASSWORD.RESET_PASS_LINK.LINK}
              </Link>
            </Typography>
          </FormControl>
        </Box>
      </Box>
    </Grid>
  );
};

CodeSendThroughEmail.propTypes = {
  formData: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,
  setFormData: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    email: PropTypes.bool,
  }).isRequired,
  setErrors: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
};
export default CodeSendThroughEmail;
